'use strict';

module.exports = typeof Promise === 'function' ? Promise : require('pinkie');



//////////////////
// WEBPACK FOOTER
// ./~/pinkie-promise/index.js
// module id = 246
// module chunks = 0 1